import { createStyles } from "../Utilities/ThemeHelper";
export const styles = createStyles(theme => ({
  dialog: {
    borderRadius: 1,
    maxHeight: "calc(100% - 96px)",
    // If this is changed, update calculateHeight() in Dialog.js
    ...theme.scrollbars?.main
  },
  dialogContent: {
    paddingBottom: theme.spacing(3),
    // If this is changed, update calculateHeight() in Dialog.js
    position: "relative",
    ...theme.scrollbars?.main,
    minHeight: 0
  },
  dialogContentMaxHeightTransition: {
    transition: theme.transitions.create(["min-height"])
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2)
  },
  title: {
    padding: "26px 86px 16px 25px"
  },
  buttons: {
    margin: 0,
    padding: theme.spacing(2)
  }
}));